import { Helmet } from "react-helmet-async";
import { useLocation } from "react-router-dom";

const SITE = "Innovated Global IT Solutions";
const DOMAIN = "https://innovatedglobal.in";

export const Seo = ({ title, description }) => {
    const { pathname } = useLocation();
    const fullTitle = title ? `${title} | ${SITE}` : `${SITE} | Ideas. Innovation. Impact.`;
    const url = `${DOMAIN}${pathname}`;
    return (
        <Helmet>
            <title>{fullTitle}</title>
            {description && <meta name="description" content={description} />}
            <link rel="canonical" href={url} />
            <meta property="og:url" content={url} />
            <meta property="og:title" content={fullTitle} />
            {description && <meta property="og:description" content={description} />}
            <meta name="twitter:title" content={fullTitle} />
            {description && <meta name="twitter:description" content={description} />}
        </Helmet>
    );
};
